

                    /*********************************************************************/
//set filter
export const setTextFilter = (text = '') => ({
    type : 'SET_TEXT_FILTER',
    text
});

                    /*********************************************************************/
//sortBy someAmount
export const sortByDate = () => ({
    type : 'SORT_BY_DATE'
})

                    /*********************************************************************/
//sortBy someAmount
export const sortByAmount = () => ({
    type : 'SORT_BY_AMOUNT'
})



                    /*********************************************************************/
//sortBy someAmount
export const setStartDate = (startDate) => ({
    type : 'SET_START_DATE',
    startDate
})



                    /*********************************************************************/
//sortBy someAmount
export const setEndDate = (endDate) => ({
    type : 'SET_END_DATE',
    endDate
})

